/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { useEffect } from 'react';
import { connect } from 'react-redux';
import logger from '../../lib/logger/logger';
import { requestNuanceNavigation as _requestNuanceNavigation } from '../../lib/store/navigation/actions';

var handleNavigationRequest = function handleNavigationRequest(_ref) {
  var requestNuanceNavigation = _ref.requestNuanceNavigation,
      nuanceNavigation = _ref.nuanceNavigation;
  var url = ((window.WF_NUANCE || {}).nuanceData || {}).DEEP_LINK_URL || '';
  requestNuanceNavigation({
    url: url,
    nuanceNavigation: nuanceNavigation
  });
};

var Nuance = function Nuance(_ref2) {
  var requestNuanceNavigation = _ref2.requestNuanceNavigation;
  useEffect(function () {
    logger.debug('Creating Nuance callback');
    window.WF_NUANCE = window.WF_NUANCE || {};

    window.WF_NUANCE.callToAction = function (nuanceNavigation) {
      return handleNavigationRequest({
        requestNuanceNavigation: requestNuanceNavigation,
        nuanceNavigation: nuanceNavigation
      });
    };
  }, [requestNuanceNavigation]);
  return null;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    requestNuanceNavigation: function requestNuanceNavigation(_ref3) {
      var url = _ref3.url,
          nuanceNavigation = _ref3.nuanceNavigation;
      return dispatch(_requestNuanceNavigation({
        url: url,
        nuanceNavigation: nuanceNavigation
      }));
    }
  };
};

export default connect(null, mapDispatchToProps)(Nuance);